import { call, put, takeLatest } from "redux-saga/effects";
import { SPSELECTS } from "../../InterfacesTypes/enums";
import { spGet } from "../../utils/SharepointAPI";
import { getEnvironment } from "../../utils/utils";
import type { IBannerImage } from "InterfacesTypes/interfaces";
import {
  fetchBannerImage,
  fetchStart,
  fetchSuccess,
  fetchFailure,
} from "state/reducers/BannerImageReducer";

const env = getEnvironment();
function* fetchBannerImagesWorker() {
  try {
    yield put(fetchStart());
    const bannerImageUrl = `${env.listapi}/GetByTitle('BannerImage')/Items?$top=5000&$select=${SPSELECTS.BANNERIMAGE}`;
    const data: IBannerImage[] = yield call(spGet, bannerImageUrl);
    yield put(fetchSuccess(data));
  } catch (err: any) {
    yield put(fetchFailure(err?.message ?? "Något gick fel"));
  }
}

export function* bannerImageSaga() {
  yield takeLatest(fetchBannerImage.type, fetchBannerImagesWorker);
}
